module.exports = __webpack_public_path__ + "static/media/29FUNOV1.cd168da7.jpg";